import React from 'react';
import styled from 'styled-components';
import { FlexBetween, FlexibleDiv } from '../../../../styled/common';
import { PlaceholderBlock } from '../../../../styled/placeholders.styled';
import { Breakpoints } from '../../../../styled/constants';

const HeaderPlaceholder = styled(FlexBetween)`
  position: relative;
  height: 60px;
  padding: 0 15px;

  @media (min-width: ${Breakpoints.tablet}px) {
    display: none;
  }
`;

const LogoPlaceholder = styled(PlaceholderBlock)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const ActionsWrapper = styled(FlexibleDiv)`
  gap: 15px;
`;

export const CurrentItemHeaderPlaceholder: React.FC = () => (
  <HeaderPlaceholder>
    <PlaceholderBlock
      height="35px"
      width="35px"
      margin="0"
      borderRadius="8px"
    />
    <LogoPlaceholder height="35px" width="80px" margin="0" borderRadius="8px" />

    <ActionsWrapper>
      <PlaceholderBlock
        height="35px"
        width="35px"
        margin="0"
        borderRadius="8px"
      />
      <PlaceholderBlock
        height="35px"
        width="35px"
        margin="0"
        borderRadius="8px"
      />
    </ActionsWrapper>
  </HeaderPlaceholder>
);
